module.exports = __webpack_public_path__ + "img/Elli-Fahrzeugschein-VW.03a78468.png";